import { useRoom } from ".";
import { useQuery } from "react-query";
import type { Cohost } from "@/react/types/Live/Cohost";
import { useLiveStreamContextData } from "@circle-react/contexts/LiveStreams";
import { canManageRoom } from "@circle-react/helpers/liveStreamRoomHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

interface CohostsListResponse {
  records: Cohost[];
}

export const useCohostsList = () => {
  const room = useRoom();
  const { currentParticipant } = useLiveStreamContextData();
  const canFetchCohosts = !!currentParticipant && canManageRoom(room);
  const {
    data,
    isLoading: isLoadingCohosts,
    refetch,
  } = useQuery<CohostsListResponse>(
    internalApi.liveStreams.getCohosts({
      roomId: room?.id,
    }),
    {
      enabled: canFetchCohosts,
    },
  );
  const refetchCohosts = () => {
    if (canFetchCohosts) {
      void refetch();
    }
  };
  const cohosts = data?.records || [];

  return {
    cohosts,
    isLoadingCohosts,
    refetchCohosts,
  };
};
